import React, { useEffect, useRef, useState } from 'react';
import { readMemoryAcl, updateMemoryAcl, createMutationIdempotencyKey, type DocRecord } from '../../lib/supabase-service';

export const parseAclUserIds = (value: string): string[] => [...new Set(value.split(/[\s,]+/).filter(Boolean))];

export const DocumentAclForm = ({ document, onClose, onSaved }: {
    document: DocRecord; onClose: () => void; onSaved: () => void;
}) => {
    const keys = useRef(new Map<string, string>());
    const [mode, setMode] = useState('INHERIT_SCOPE');
    const [users, setUsers] = useState('');
    const [revision, setRevision] = useState<number>();
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(true);
    useEffect(() => {
        let live = true;
        readMemoryAcl(document.id).then(acl => {
            if (!live) return;
            setMode(acl.acl_mode);
            setUsers(acl.user_ids.join('\n'));
            setRevision(acl.revision);
            setBusy(false);
        }).catch(error => { if (live) { setError(error.message); setBusy(false); } });
        return () => { live = false; };
    }, [document.id]);
    return <div role="dialog" aria-modal="true" aria-label="Acceso documental" className="fixed inset-0 z-50 bg-slate-950/90 flex items-center justify-center p-6 text-white">
        <form className="bg-slate-900 p-6 rounded-2xl space-y-4 max-w-lg w-full" onSubmit={async event => {
            event.preventDefault();
            setBusy(true);
            setError('');
            const userIds = mode === 'INHERIT_SCOPE' ? [] : parseAclUserIds(users);
            const fingerprint = JSON.stringify([revision, mode, userIds]);
            if (!keys.current.has(fingerprint)) keys.current.set(fingerprint, createMutationIdempotencyKey());
            try {
                await updateMemoryAcl(document.id, revision!, mode, userIds, { idempotencyKey: keys.current.get(fingerprint) });
                onSaved();
                onClose();
            } catch (error: any) { setError(error.message); }
            finally { setBusy(false); }
        }}>
            <h2>Acceso documental</h2>
            <p>El acceso siempre requiere permiso de Memoria y alcance institucional. Una lista restringida vacía deniega el acceso, incluido el administrador.</p>
            <label className="block">Modo
                <select className="block bg-slate-800 p-3 w-full" value={mode} onChange={event => setMode(event.target.value)}>
                    <option value="INHERIT_SCOPE">Heredar alcance</option><option value="RESTRICTED">Restringido</option>
                </select>
            </label>
            {mode === 'RESTRICTED' && <label className="block">Identificadores de usuarios autorizados
                <textarea className="block bg-slate-800 p-3 w-full" value={users} onChange={event => setUsers(event.target.value)} placeholder="Un UUID de usuario por línea" />
            </label>}
            {error && <p role="alert">{error}</p>}
            <button disabled={busy || !revision} className="bg-indigo-600 p-3 rounded-xl">Guardar acceso</button>
            <button type="button" onClick={onClose}>Cancelar</button>
        </form>
    </div>;
};
